
import utilReceiptPOS from '../util/util-receipt-pos'; 
import printManager from '../print-manager';

class Turn {
	constructor() {
		
	}

	async printTurn(store, turn, filters, db){
		console.log(turn);
		let fontSize = '15';
		let installation = store.getters.installation;		
		if (installation) {
			const cashRegister = await db.getCashRegister(
			  installation.cash_id
			);
			if(cashRegister){
				if(cashRegister.config){
					if(cashRegister.config.pos_printer_font_size){
						fontSize = cashRegister.config.pos_printer_font_size;
					}
				}
			}
		}
		const receipt = new utilReceiptPOS(store, fontSize, filters, db);	
		await receipt.setDataCompany();
		receipt.setTitle("Cuadre de Turno");
		receipt.stackTotals = true;
		if(turn.cash_register && turn.cash_register.name){
			receipt.setReference(turn.cash_register.name);
		}

		/*if(turn.user_created_id ){
			let employee= await db.getEmployeeById(turn.user_created_id);
			if(employee){
				receipt.addHeaderText("Abierto por:");
				receipt.addHeaderText(employee.name);
			}
		}*/
		if(turn.opening_date){
			receipt.setTurnOpeningDate(filters.localdatetime(turn.opening_date));			
		}
		if(turn.closing_date){
			receipt.setTurnClosingDate(filters.localdatetime(turn.closing_date));			
		}
		
		await receipt.addHeader('turn');
		let tableItems = [];
		let faltan = 0;
		let sobran = 0;
		// Un cierre anterior al detalle por medio no guardó cómo se contó la base: ahí vale la diferencia guardada.
		let detallePorMedio = true;
		if(turn.data_payments){
			for (const row of turn.data_payments) {
				let item = [];
				// Efectivo de un cierre nuevo: lo que debía haber ya descuenta egresos y notas crédito y suma la base.
				let esperado = Number(row['system_value']) || 0;
				let etiqueta = ' Sistema: ';
				if (String(row['id']) === '10' && row['credit_notes_returned'] !== undefined) {
					esperado += (row['base_counted'] === false ? 0 : (Number(turn.starting_amount) || 0))
						- (Number(turn.cash_expenses_amount) || 0)
						- (Number(row['credit_notes_returned']) || 0);
					etiqueta = ' Debe haber: ';
				} else if (String(row['id']) === '10') {
					detallePorMedio = false;
				}
				item.push(row['name'] + etiqueta + filters.currency(esperado, 0));
				item.push(row['name'] + ' Registrado:' + filters.currency(row['counted_value'], 0) );			
				// Cada medio se juzga solo: lo que falta en uno no se compensa con lo que sobra en otro.
				const dif = Math.round((esperado - (Number(row['counted_value']) || 0)) * 100) / 100;
				if (dif > 0) {
					faltan += dif;
					item.push(row['name'] + ' FALTAN: ' + filters.currency(dif, 0));
				} else if (dif < 0) {
					sobran += -dif;
					item.push(row['name'] + ' SOBRAN: ' + filters.currency(-dif, 0));
				}
				tableItems.push( item );				
			}
			receipt.addTable( tableItems, false, (fontSize - 1));
		}

		receipt.pushTotal('Monto Inicial', turn.starting_amount , fontSize);
		receipt.pushTotal('Total Ventas', turn.total_sales, fontSize);
		if (turn.cash_expenses_amount) {
			receipt.pushTotal('Egresos en efectivo', turn.cash_expenses_amount, fontSize);
		}
		if (turn.other_expenses_amount) {
			receipt.pushTotal('Egresos otros medios', turn.other_expenses_amount, fontSize);
		}
		if (turn.credit_notes_amount) {
			receipt.pushTotal('Notas credito', turn.credit_notes_amount, fontSize);
		}
		if (turn.gift_cards_sold_amount) {
			receipt.pushTotal('Tarjetas regalo vendidas', turn.gift_cards_sold_amount, fontSize);
		}
		if (turn.gift_card_paid_amount) {
			receipt.pushTotal('Pagado con tarjeta regalo', turn.gift_card_paid_amount, fontSize);
		}
		if (turn.credit_notes_returned_amount) {
			receipt.pushTotal('Notas credito pagadas del cajon', turn.credit_notes_returned_amount, fontSize);
		}
		receipt.pushTotal('Monto Registrado', (turn.data_payments || []).reduce((t, r) => t + (Number(r.counted_value) || 0), 0), fontSize);
		if (detallePorMedio && turn.data_payments && turn.data_payments.length > 0) {
			if (faltan === 0 && sobran === 0) {
				receipt.pushTotal('Cuadrado', 0, fontSize);
			}
			if (faltan > 0) {
				receipt.pushTotal('Faltan', faltan, fontSize);
			}
			if (sobran > 0) {
				receipt.pushTotal('Sobran', sobran, fontSize);
			}
		} else {
			// difference = esperado - contado: positivo = faltante.
			const dif = Number(turn.difference) || 0;
			receipt.pushTotal(dif > 0 ? 'Faltan' : (dif < 0 ? 'Sobran' : 'Cuadrado'), Math.abs(dif), fontSize);
		}
		if (turn.annulled_orders_count) {
			receipt.pushTotal('Ordenes anuladas (' + turn.annulled_orders_count + ')', turn.annulled_orders_amount, fontSize);
		}
		receipt.pushTotal('Total Domicilios', turn.delivery_amount, fontSize);
		receipt.pushTotal('Total Propinas', turn.tip_amount, fontSize);		
		receipt.addTotals();	
		
		

		if(turn.observation){
			receipt.addText(turn.observation, 'justify', (fontSize ));
		}
		receipt.addFooter();		
		printManager.printFromFormat(receipt.render(), store, filters, db); 		
	}

	async printFiscalReport(store, turn, filters, db){	
		
		
		
		let fontSize = '15';
		let installation = store.getters.installation;		
		if (installation) {
			const cashRegister = await db.getCashRegister(
			  installation.cash_id
			);
			if(cashRegister){
				if(cashRegister.config){
					if(cashRegister.config.pos_printer_font_size){
						fontSize = cashRegister.config.pos_printer_font_size;
					}
				}
			}
		}
		const receipt = new utilReceiptPOS(store, fontSize, filters, db);	
		await receipt.setDataCompany();
		receipt.setTitle("Reporte Fiscal");
		
		if(turn.cash_register && turn.cash_register.name){
			receipt.setReference(turn.cash_register.name);
		}

		if(turn.user_created_id ){
			let employee= await db.getEmployeeById(turn.user_created_id);
			if(employee){
				receipt.addHeaderText("Abierto por: " + employee.name);
			}
		}
		if(turn.opening_date){
			receipt.setTurnOpeningDate(filters.localdatetime(turn.opening_date));			
		}
		if(turn.closing_date){
			receipt.setTurnClosingDate(filters.localdatetime(turn.closing_date));			
		}else{
			receipt.setTurnClosingDate('N/A');
		}
		await receipt.addHeader('turn');

		const items = await this.calculateFiscalReportOffline(store, turn, filters, db);
		if(items && items.length > 0){
			for (const row of items) {
				receipt.addText(row.label + ": " + row.value, 'left', (fontSize ));
			}			
		} else {
			receipt.addText("No hay ventas en el turno actual", 'justify', (fontSize ));
		}
		
		/*
		
		let tableItems = [];
		if(turn.data_payments){
			for (const row of turn.data_payments) {
				let item = [];
				item.push(row['name'] + ' Sistema: ' + filters.currency(row['system_value'], 0));
				item.push(row['name'] + ' Registrado:' + filters.currency(row['counted_value'], 0) );			
				tableItems.push( item );				
			}
			receipt.addTable( tableItems, false, (fontSize - 1));
		}

		receipt.pushTotal('Monto Inicial', turn.starting_amount , fontSize);
		receipt.pushTotal('Total Ventas', turn.total_sales, fontSize);
		receipt.pushTotal('Monto Registrado', (turn.data_payments || []).reduce((t, r) => t + (Number(r.counted_value) || 0), 0), fontSize);
		receipt.pushTotal('Diferencia', turn.difference, fontSize);
		receipt.pushTotal('Total Domicilios', turn.delivery_amount, fontSize);
		receipt.pushTotal('Total Propinas', turn.tip_amount, fontSize);
		
		receipt.addTotals();
		if(turn.observation){
			receipt.addText(turn.observation, 'justify', (fontSize ));
		}*/
		receipt.addFooter();		
		printManager.printFromFormat(receipt.render(), store, filters, db); 		
	}

	async calculateFiscalReportOffline(store, turn, filters, db) {
		let items = []
		let orders = [];
		orders = await db.getOrdersByTurnOrderConsecutive(turn);
		if(orders && orders.length > 0){
			const firstOrder = orders[0];
			const lastOrder = orders[orders.length - 1];
			const totalOrders = await this.calculateTotalsOrders(orders);
			// console.log(firstOrder);
			items.push({'label': 'Consecutivo Inicial', 'value': firstOrder.consecutive_order_text});
			items.push({'label': 'Consecutivo Final', 'value': lastOrder.consecutive_order_text});
			items.push({'label': 'Cantidad de transacciones', 'value': orders.length});
			items.push({'label': 'Valor total transacciones', 'value': totalOrders.total_sales});
			

			// items = orders;			
		}
		return items;
	}

	async calculateTotalsOrders(orders) {
		let total = {
			total_sales: 0,
			total_taxes: 0
		}
		for (const order of orders) {
			console.log(order);
		  if(!isNaN(order.total_factura)){
			if(!isNaN(order.total_impuestos)){
			  
			}        
		  }
		  if(!isNaN(order.valor_propina)){
			// this.totalPropinas += order.valor_propina;
		  }
		}
		return total;
	  }

}

export default Turn;